import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { DEVELOPMENT_TYPE } from "Constants";
import AddTrack from "./addtrack";
import AddTrackSession from "./newsession";
import ImportSchedules from "./schedule-import";
import DownloadSchedules from "./dowloadschedules";
import CopyEmbeddedCode from "./copyembeddedcode";
import DeleteSchedule from "./delete-schedule";
import InfoTutorial from "InfoTutorial";

var ScheduleHeaderButtons = ({
  finishOperationsCallback,
  history,
  selectedScheduleDate,
}) => {
  let hideTrack = true;
  if (!_.isEmpty(selectedScheduleDate)) {
    let tracksForSelectedDate =
      selectedScheduleDate.ScheduleDateToScheduletracks
        ? selectedScheduleDate.ScheduleDateToScheduletracks
        : [];

    // Check for selected date track required or not
    let checkTrackStatus = _.filter(tracksForSelectedDate, (o) => {
      return o.trackname === "##NOTRACK##";
    });

    if (checkTrackStatus.length == 0) {
      hideTrack = false;
    }
  }

  return DEVELOPMENT_TYPE === "eventify" ? (
    <ul className="header-buttons">
      {hideTrack ? null : (
        <li>
          <AddTrack history={history} />
        </li>
      )}
      <li>
        <AddTrackSession history={history} />
      </li>
      <li>
        <ImportSchedules
          callbackFinalData={finishOperationsCallback}
          history={history}
        />
      </li>
      <li>
        <DownloadSchedules />
      </li>
      <li>
        <CopyEmbeddedCode />
      </li>
      <li>
        <DeleteSchedule />
      </li>
      <li>
        <InfoTutorial video="schedules.mp4" />
      </li>
    </ul>
  ) : (
    <ul className="header-buttons">
      <li>
        <AddTrackSession history={history} />
      </li>
      <li>
        <InfoTutorial video="schedules.mp4" />
      </li>
    </ul>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    history: ownProps.history,
  };
}

export default withRouter(connect(mapStateToProps, {})(ScheduleHeaderButtons));
